// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 支付成功页优化 */
.pay-success-page { min-height:100vh; background:var(--color-bg); display:flex; flex-direction:column; }
.success-header { text-align:center; }

.success-card { position:relative; margin:34px 0 28px; padding:46px 30px 48px; border-radius:28px; overflow:hidden; }
.success-card::before { content:""; position:absolute; inset:0; background:radial-gradient(circle at 40% 20%,rgba(99,102,241,.15),rgba(255,255,255,0) 70%); pointer-events:none; }

.icon { font-size:54px; margin:0 0 14px; filter:drop-shadow(0 4px 8px rgba(0,0,0,.15)); animation:pulseSoft 2.6s infinite; }
.success-card h2 { margin:0 0 14px; font-size:1.6rem; letter-spacing:1px; background:linear-gradient(90deg,var(--color-primary),var(--color-primary-accent)); -webkit-background-clip:text; background-clip:text; color:transparent; }
.hint { color:var(--color-text-sec); margin:8px auto 30px; max-width:480px; font-size:.9rem; line-height:1.6; }

.actions { display:flex; flex-wrap:wrap; gap:14px; justify-content:center; }
.actions .btn { padding:13px 20px; border-radius:14px; min-width:160px; }
@media (max-width:520px) { .actions { flex-direction:column; } .actions .btn { width:100%; } }

/* 预约信息摘要样式 */
.booking-summary {
  background: rgba(99, 102, 241, 0.05);
  border: 1px solid rgba(99, 102, 241, 0.2);
  border-radius: 16px;
  padding: 20px;
  margin: 24px 0;
  text-align: left;
}

.booking-summary h3 {
  margin: 0 0 16px;
  color: var(--color-text);
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
}

.booking-details {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.booking-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  line-height: 1.5;
}

.booking-item .label {
  color: var(--color-text-sec);
  font-size: 0.85rem;
  font-weight: 500;
  min-width: 80px;
  flex-shrink: 0;
}

.booking-item .value {
  color: var(--color-text);
  font-size: 0.85rem;
  flex: 1 1;
  word-break: break-word;
}

@media (max-width: 480px) {
  .booking-item {
    flex-direction: column;
    gap: 4px;
  }
  
  .booking-item .label {
    min-width: auto;
    font-weight: 600;
  }
  
  .success-card {
    padding: 36px 20px 38px;
  }
}

@keyframes pulseSoft {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

`, "",{"version":3,"sources":["webpack://./src/components/PaymentSuccess.css"],"names":[],"mappings":"AAAA,YAAY;AACZ,oBAAoB,gBAAgB,EAAE,0BAA0B,EAAE,YAAY,EAAE,qBAAqB,EAAE;AACvG,kBAAkB,iBAAiB,EAAE;;AAErC,gBAAgB,iBAAiB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACpH,wBAAwB,UAAU,EAAE,iBAAiB,EAAE,OAAO,EAAE,0FAA0F,EAAE,mBAAmB,EAAE;;AAEjL,QAAQ,cAAc,EAAE,eAAe,EAAE,6CAA6C,EAAE,iCAAiC,EAAE;AAC3H,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,kFAAkF,EAAE,4BAA4B,EAAE,oBAAoB,EAAE,iBAAiB,EAAE;AACrO,QAAQ,2BAA2B,EAAE,oBAAoB,EAAE,eAAe,EAAE,eAAe,EAAE,eAAe,EAAE;;AAE9G,WAAW,YAAY,EAAE,cAAc,EAAE,QAAQ,EAAE,sBAAsB,EAAE;AAC3E,gBAAgB,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACxE,2BAA2B,WAAW,qBAAqB,EAAE,EAAE,gBAAgB,UAAU,EAAE,EAAE;;AAE7F,aAAa;AACb;EACE,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,SAAO;EACP,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC","sourcesContent":["/* 支付成功页优化 */\n.pay-success-page { min-height:100vh; background:var(--color-bg); display:flex; flex-direction:column; }\n.success-header { text-align:center; }\n\n.success-card { position:relative; margin:34px 0 28px; padding:46px 30px 48px; border-radius:28px; overflow:hidden; }\n.success-card::before { content:\"\"; position:absolute; inset:0; background:radial-gradient(circle at 40% 20%,rgba(99,102,241,.15),rgba(255,255,255,0) 70%); pointer-events:none; }\n\n.icon { font-size:54px; margin:0 0 14px; filter:drop-shadow(0 4px 8px rgba(0,0,0,.15)); animation:pulseSoft 2.6s infinite; }\n.success-card h2 { margin:0 0 14px; font-size:1.6rem; letter-spacing:1px; background:linear-gradient(90deg,var(--color-primary),var(--color-primary-accent)); -webkit-background-clip:text; background-clip:text; color:transparent; }\n.hint { color:var(--color-text-sec); margin:8px auto 30px; max-width:480px; font-size:.9rem; line-height:1.6; }\n\n.actions { display:flex; flex-wrap:wrap; gap:14px; justify-content:center; }\n.actions .btn { padding:13px 20px; border-radius:14px; min-width:160px; }\n@media (max-width:520px) { .actions { flex-direction:column; } .actions .btn { width:100%; } }\n\n/* 预约信息摘要样式 */\n.booking-summary {\n  background: rgba(99, 102, 241, 0.05);\n  border: 1px solid rgba(99, 102, 241, 0.2);\n  border-radius: 16px;\n  padding: 20px;\n  margin: 24px 0;\n  text-align: left;\n}\n\n.booking-summary h3 {\n  margin: 0 0 16px;\n  color: var(--color-text);\n  font-size: 1rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n.booking-details {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.booking-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  line-height: 1.5;\n}\n\n.booking-item .label {\n  color: var(--color-text-sec);\n  font-size: 0.85rem;\n  font-weight: 500;\n  min-width: 80px;\n  flex-shrink: 0;\n}\n\n.booking-item .value {\n  color: var(--color-text);\n  font-size: 0.85rem;\n  flex: 1;\n  word-break: break-word;\n}\n\n@media (max-width: 480px) {\n  .booking-item {\n    flex-direction: column;\n    gap: 4px;\n  }\n  \n  .booking-item .label {\n    min-width: auto;\n    font-weight: 600;\n  }\n  \n  .success-card {\n    padding: 36px 20px 38px;\n  }\n}\n\n@keyframes pulseSoft {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.05); }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
